import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { API } from "aws-amplify";
import Form from "react-bootstrap/Form"
import { Container, Row, Col } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import { onError, Notification } from "../libs/errorLib";
import CardGroup from '../components/common/CardGroup';

//import "./Login.css";
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import { LinkContainer } from "react-router-bootstrap";

export default function PasswordReset() {  
  const { token } = useParams();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [fields, handleFieldChange] = useFormFields({    
    password: "",
    confirmPassword: ""
  });

  async function resetPassword(password) {
    
    try {
        const result = await API.post('vivelo',`/auth/password/reset`, {
          body: { token: token, password: password }
        })        
        return true;
    } catch(e) {            
      console.log(e)                      
      return false
    }    
  }

  function validateForm() {
    return fields.password.length > 0 && fields.password === fields.confirmPassword;
  }

  async function handleSubmit(event) {
    event.preventDefault();
  
    setIsLoading(true);

    try {
      const result = await resetPassword(fields.password) 
      if (result) {
        history.push(`/login`)
        
      } else {
        Notification('error', 'No fue posible reestabler la contrase&ntilde;a')
        setIsLoading(false);
      }

    } catch (e) {
        onError(e);
        Notification('error', 'No fue posible reestabler la contrase&ntilde;a')        
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="content content-dark login-center-container">
      <CardGroup className="auth-card">
        <h1>Reestablecer contraseña</h1>
        <div className="description">Ingresa tu nueva contraseña</div>
        <Form onSubmit={handleSubmit} className="auth-form">
          <Form.Group controlId="password" size="lg">
            <Form.Label>Nueva contraseña</Form.Label>
            <Form.Control
              autoFocus
              type="password"
              value={fields.password}
              onChange={handleFieldChange}
              className="input-theme"
            />
          </Form.Group>
          <Form.Group controlId="confirmPassword" size="lg">
            <Form.Label>Confirma tu contraseña</Form.Label>
            <Form.Control
              type="password"
              onChange={handleFieldChange}
              value={fields.confirmPassword}
              className="input-theme"
            />
          </Form.Group>
          <LoaderButton
            block
            type="submit"
            size="lg"
            isLoading={isLoading}
            disabled={!validateForm()}
            className="btn-theme-primary btn-block"
          >
            Reestablecer Contraseña
          </LoaderButton>
        </Form>
      </CardGroup>
    </div>
  );
}